import constants from "../Utils/constants";
const initialState = {
  siteVisitDetails: [],
  isGetSiteVisitDetailsLoading: false,
  isCreateSiteVisitDetailsLoading: false,
};

const siteVisitDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_SITE_VISIT_DETAILS_REQUEST:
      return {
        ...state,
        isGetSiteVisitDetailsLoading: true,
      };
    case constants.GET_SITE_VISIT_DETAILS_SUCCESS:
      return {
        ...state,
        isGetSiteVisitDetailsLoading: false,
        siteVisitDetails: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.site_visit_details || [],
      };
    case constants.GET_SITE_VISIT_DETAILS_FAILURE:
      return {
        ...state,
        isGetSiteVisitDetailsLoading: false,
      };

    case constants.CREATE_SITE_VISIT_DETAILS_REQUEST:
      return {
        ...state,
        isCreateSiteVisitDetailsLoading: true,
      };
    case constants.CREATE_SITE_VISIT_DETAILS_SUCCESS:
      return {
        ...state,
        isCreateSiteVisitDetailsLoading: false,
      };
    case constants.CREATE_SITE_VISIT_DETAILS_FAILURE:
      return {
        ...state,
        isCreateSiteVisitDetailsLoading: false,
      };

    // case constants.UPDATE_LEAD_REQUEST:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: true,
    //   };
    // case constants.UPDATE_LEAD_SUCCESS:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: false,
    //   };
    // case constants.UPDATE_LEAD_FAILURE:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: false,
    //   };

    // case constants.DELETE_LEAD_REQUEST:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: true,
    //   };
    // case constants.DELETE_LEAD_SUCCESS:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: false,
    //   };
    // case constants.DELETE_LEAD_FAILURE:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: false,
    //   };
    case "REMOVING_USER_CREDENTIALS":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
export default siteVisitDetailsReducer;
